import { StorageClientKeys } from 'core/models/clients';

class StorageClient {
  static instance: StorageClient;

  public getInstance() {
    if (!this.healthCheck) return null;
    if (!StorageClient.instance) StorageClient.instance = new StorageClient();
    return StorageClient.instance;
  }

  private healthCheck() {
    try {
      const key = '__QUILLBOT_TEST___';
      window.localStorage.setItem(key, key);
      window.localStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  get(key: StorageClientKeys) {
    window.localStorage.getItem(key);
  }

  set(key: StorageClientKeys, value: unknown) {
    window.localStorage.setItem(key, `${value}`);
  }

  dangerouslyClearStorage() {
    window.localStorage.clear();
  }
}

export default StorageClient;
export { StorageClient };
